export const htmlIsEmpty = (html: string | null | undefined): boolean =>
  !html || html.replace(/<[^>]+>/g, '').trim().length === 0;
